import "./Projects.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Gallery from "./sections/Gallery";
import DecaturHousingGuide from "./sections/DecaturHousingGuide";
import Results from "./sections/Results";
import Footer from "@/reusable_sections/Footer";
export default function ProjectsPage() {
  return <div>
      <Header />
      <Hero />
      <DecaturHousingGuide />
      <Gallery />
      <Results />
      <Footer />
    </div>;
}